class Admin_list {
	constructor(element) {
		this.$element = $(element);

		this.data = {
			pluginName: 'plugin-name',
			sort: 'sort',
			sortSendType: 'sort-send-type'
		};
	}

	init() {
		// console.log('Admin_list init()');

		this.dataPlugin = this.$element.data(this.data.pluginName);
		this.dataSort = this.$element.data(this.data.sort);
		this.dataSortSendType = this.$element.data(this.data.sortSendType);

		if (this.dataSort) {
			this.initSort();
		}
	}

	initSort() {
		i4_Sort.factory(this.$element, 'js='+this.dataPlugin).
	    	set_handles('js-sort-handle').
	    	set_send_type(this.dataSortSendType).
	    	set_constraint('vertical').
	    	run();
	}
}
